<template>
  <div id="phb">
    <van-notice-bar wrapable color="#1989fa" background="#ecf9ff" left-icon="volume-o" text="该榜单仅作“阿狮警长说反诈”活动学生产生的总积分参考，该积分将与其他反诈子项目中学生积分相加后取平均值汇总到年底学校反诈系列活动积分榜单。"></van-notice-bar>
    <!-- 排行榜 -->
    <div class="ranking">
      <div class="phb-banner">
        <img
          src="https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782894322716.png"
          width="100%"
        />
      </div>

      <div class="lists">
        <table>
          <thead>
            <tr>
              <td>排名</td>
              <td>学校</td>
              <td>积分</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, k) in list" :key="k">
              <td class="key" :style="bgColor(k)">{{k + 1}}</td>
              <td>{{ v.name }}</td>
              <td>{{v.integral}}</td>
            </tr>
          </tbody>
        </table>
        <div class="bangdan">榜单只显示前40名</div>
      </div>
    
    </div>
  </div>
</template>

<script>
import { schoolRankingList } from "@/api/fanzha";

export default {
  name: "Phb",
  data() {
    return {
      list: [],
      themeId: 3,
    };
  },
  mounted() {
    schoolRankingList({ theme_id: this.themeId, limit: 40 }).then(
      (res) => {
        if (res.code == 1) {
          this.list = res.data;
        }

      }
    );
  },
  methods: {
    bgColor(k){
      let color = '';
      switch(k){
        case 0:
          color = '#df1715';
          break;
        case 1:
          color = '#e94a1f';
          break;
        case 2:
          color = '#f5b630';
          break;
        default:
          color = '#0e3f97';
          break;
      }
      return 'background-color: ' + color;
    }
  }
};
</script>

<style lang="less" scoped>
#phb {
  .ranking {
    position: relative;
    background-color: #8ba9f2;
    border-radius: 15px;
    margin: 40px 10px auto auto;
    .phb-banner {
      position: absolute;
      top: -20px;
      width: 84vw;
      left: 50%;
      margin-left: -42vw;
      img {
        width: 100%;
      }
    }
    .lists {
      padding: 110px 10px 10px 10px;
      table {
        border-collapse: separate;
        border-spacing: 0 10px;
        width: 100%;
        thead{
          font-style: oblique;
          text-align: center;
          font-weight: bold;
        }
        tbody {
          .key {
            color: #fff;
            font-weight: bold;
            width: 30px;
          }
          tr{
            height: 30px;
            line-height: 30px;
            background-color: #fff;
            color: #0e3f97;
            td {
              padding-left: 5px;
            }
          }
        }
      }
      .bangdan {
        text-align: center;
        margin: 10px auto;
      }
    }
  }
}
</style>
